const AUTH_HEADER = "Authorization";
const CONTENT_TYPE_HEADER = "Content-Type";
const DEFAULT_METHOD = "PUT";
const EMPTY_PAYLOAD = "[]";
const JSON_CONTENT_TYPE = "application/json;charset=utf-8";

export class Request {
  constructor(path) {
    if (typeof path !== "string" || path.length === 0) {
      throw new Error("path URI required");
    }

    this.method = DEFAULT_METHOD;
    this.path = path;

    this.get = this.get.bind(this);
    this.put = this.put.bind(this);
    this.send = this.send.bind(this);
  }

  get() {
    this.method = "GET";
    return this.send();
  }

  put(data) {
    if (typeof data !== "object" || Object.keys(data).length === 0) {
      return Promise.reject("No data to send");
    }
    this.method = "PUT";
    return this.send(data);
  }

  send(data, options = {}) {
    const request = new XMLHttpRequest();
    let payload = EMPTY_PAYLOAD;

    try {
      payload = JSON.stringify(data);
    } catch (e) {
      return Promise.reject("Invalid JSON");
    }

    return new Promise((resolve, reject) => {
      request.addEventListener("load", function () {
        if (this.status !== 200) {
          reject(new Error(this.statusText));
        } else {
          resolve(this.responseText);
        }
      });

      request.addEventListener("error", function (e) {
        reject(e);
      });

      request.open(this.method, this.path, true);
      request.setRequestHeader(CONTENT_TYPE_HEADER, JSON_CONTENT_TYPE);
      request.send(payload);
    });
  }
}
